import React, { useRef } from 'react';
import { Button } from '@themesberg/react-bootstrap';
import { GoogleLogin } from '@react-oauth/google';

const CustomGoogleLogin = ({ onSuccess, onError, loading }) => {
  const googleLoginRef = useRef(null);

  const handleCustomClick = () => {
    // Intentar hacer click en el botón de Google oculto
    if (googleLoginRef.current) {
      const googleButton = googleLoginRef.current.querySelector('div[role="button"]');
      if (googleButton) {
        googleButton.click();
      }
    }
  };

  return (
    <div className="custom-google-container">
      {/* Botón de Google oculto */}
      <div ref={googleLoginRef} style={{ display: 'none' }}>
        <GoogleLogin
          onSuccess={onSuccess}
          onError={onError}
          text="signin_with"
          shape="rectangular"
          theme="outline"
          size="large"
          scope="openid email profile"
          access_type="offline"
          prompt="consent"
        />
      </div>
      
      {/* Botón personalizado visible */}
      <Button 
        className="custom-google-login"
        onClick={handleCustomClick}
        disabled={loading}
      >
        Acceder con tu cuenta institucional
      </Button>
    </div>
  );
};

export default CustomGoogleLogin;